"use client";

import { useTranslations } from "next-intl";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { CaloriesCalculatorDialog } from "./calories-calculator-dialog";

type CaloriesCalculatorTriggerProps = {
  /**
   * `link` — podlinkowany tekst przy nagłówku sekcji (desktop),
   * `button` — pełnej szerokości przycisk z obramowaniem wewnątrz karty (mobile).
   */
  variant?: "link" | "button";
  className?: string;
};

/**
 * Otwiera kalkulator w wariancie informacyjnym — pokazuje wyliczoną kaloryczność,
 * ale nie zmienia niczego w konfiguracji diety (tak samo jak w aplikacji mobilnej).
 */
export const CaloriesCalculatorTrigger = ({
  className,
  variant = "link",
}: CaloriesCalculatorTriggerProps) => {
  const t = useTranslations("calories-calculator");
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Button
        className={cn(
          variant === "link"
            ? "h-auto min-h-0 p-0 text-base"
            : "w-full bg-transparent font-medium",
          className,
        )}
        onClick={() => setIsOpen(true)}
        type="button"
        variant={variant === "link" ? "link" : "outline"}
      >
        {t("trigger")}
      </Button>

      <CaloriesCalculatorDialog onOpenChange={setIsOpen} open={isOpen} />
    </>
  );
};
